import { ACTION_TYPES, useNewsDispatch, useNewsState } from "./news-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { INewsPagedRequest } from "models/request/news-paged-request";

export const useNewsController = () => {
    const newsDispatch = useNewsDispatch();
    const { newsPagedRequest } = useNewsState();

    async function onInit() {
        let request = { page: 0, pageSize: 8 } as INewsPagedRequest;
        
        newsDispatch({
            type: ACTION_TYPES.setNewsPagedRequest,
            payload: request,
        });
        newsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: true,
        });

        await listNews(request);

        await listCategoriesNews();

        newsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: false,
        });
    }

    async function listCategoriesNews() {
        try {

            const categoriesNews = await MunicipalPortalAAppService.listCategoriesNews();

            newsDispatch({
                type: ACTION_TYPES.setCategoriesNews,
                payload: categoriesNews,
            });
        } catch (error) {
            console.log(error);

        }
    }
    async function listNews(request: INewsPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                newsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: true,
                });
            }
            const news = await MunicipalPortalAAppService.listNews(request);

            newsDispatch({
                type: ACTION_TYPES.setNews,
                payload: news,
            });

            if (showLoading) {
                newsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: false,
                });
            }
        } catch (error) {
            console.log(error);

        }
    }


    const handleOnChange = (e: any) => {
        let term = newsPagedRequest?.term;
        let categoryId = newsPagedRequest?.categoryId;


        if (e.target.name === "text-field-term") {
            term = e.target.value;

            if (term === null || term === undefined || term === "") {
                (async () => {
                    await listNews({ page: 0, pageSize: 8 } as INewsPagedRequest);

                })()

            }
        } else if (e.target.name === "select-category-id") {
            categoryId = e.target.value;
        }


        newsDispatch({
            type: ACTION_TYPES.setNewsPagedRequest,
            payload: { ...newsPagedRequest, term, categoryId },
        });
    };

    return {
        listNews, handleOnChange, onInit
    };
}